import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000,
});

export const fetchStatus = () => api.get("/status").then((r) => r.data);
export const fetchLatest = () => api.get("/losers/latest").then((r) => r.data);
export const fetchDates = () => api.get("/losers/dates").then((r) => r.data);
export const fetchByDate = (d) => api.get(`/losers/${d}`).then((r) => r.data);
export const triggerScan = () => api.post("/scan").then((r) => r.data);
export const triggerScanAsync = () => api.post("/scan/async").then((r) => r.data);
export const fetchStock = (t, days = 30) =>
  api.get(`/stock/${t}/history`, { params: { days } }).then((r) => r.data);
export const fetchStockNews = (t, changePct) =>
  api
    .get(`/stock/${t}/news`, {
      params: changePct != null ? { change_pct: changePct } : {},
      timeout: 120000,
    })
    .then((r) => r.data);
